import React from 'react';
import { useTranslation } from 'next-i18next';

import { Box } from '@mui/material';

import { styledComponent } from 'src/utils/styled';
import { colours } from 'src/constants/colours';
import Typography from 'src/components/ui/Typography';
import { PartnershipBlock } from './PartnershipBlock';
import useDynamicLogEvents from 'src/hooks/useDynamicLogEvents';
import { AnalyticsEvent } from 'src/utils/analytics';

const PartnershipsContainer = styledComponent(Box)`
    background-color: ${colours.paleLightBlue};
    border-radius: 1rem;
    padding: 1.5rem;
`;

const Title = styledComponent(Typography)`
    color: ${colours.primary.main};
    font-size: 1.25rem;
`;

type Props = {
    partnershipBlockWidth?: string;
    direction?: 'row' | 'column';
};

export const PartnershipsBlock: React.FC<Props> = ({ partnershipBlockWidth, direction }) => {
    const { t } = useTranslation(['partnerships']);
    const { logEventDynamic } = useDynamicLogEvents();

    const logClickEvent = () => {
        logEventDynamic(AnalyticsEvent.ClickOnIlekPartnerLink);
    };

    return (
        <PartnershipsContainer>
            <Title variant="h2" marginBottom="1rem">
                {t('partnerships:title')}
            </Title>
            <Box display="flex" gap="1rem" flexDirection={direction}>
                <PartnershipBlock
                    imageUrl={`${process.env.NEXT_PUBLIC_SITE_URL}/assets/images/partnership/ilek.png`}
                    title={t('partnerships:ilek.tagline')}
                    description={t('partnerships:ilek.description')}
                    buttonText={t('partnerships:ilek.cta')}
                    buttonHref="https://www.ilek.fr/particuliers/tunnel/woopen"
                    buttonOnClick={logClickEvent}
                    width={partnershipBlockWidth}
                />
            </Box>
        </PartnershipsContainer>
    );
};
